<script setup lang="ts">
  import {
    ScrollAreaCorner,
    ScrollAreaRoot,
    type ScrollAreaRootProps,
    ScrollAreaViewport
  } from 'reka-ui'
  import { computed, onMounted, useTemplateRef, type HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'
  import ScrollBar from './ScrollBar.vue'

  const props = defineProps<
    ScrollAreaRootProps & {
      class?: HTMLAttributes['class']
      tabindex?: string
      // viewportProps?: ScrollAreaViewportProps
    }
  >()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })

  /** DONT DELETE UNLESS RADIX-VUE HAS A BUGFIX FOR tabindex.
   * This is a hack that fixes scroll-area's tabindex being set to "0" by default.
   * We don't want the scrollarea to be targeted by tab-key unless it's explicitly set to "0" by a developer for some reason.
   */
  const sa = useTemplateRef('scroll-area')

  onMounted(() => {
    const tabindex = props.tabindex ?? '-1'
    sa.value?.viewportElement?.setAttribute('tabindex', tabindex)
  })
</script>

<template>
  <ScrollAreaRoot
    data-slot="scroll-area"
    v-bind="delegatedProps"
    :class="cn('relative overflow-hidden', props.class)"
  >
    <ScrollAreaViewport
      ref="scroll-area"
      data-slot="scroll-area-viewport"
      class="focus-visible:ring-ring/50 size-full rounded-[inherit] outline-none transition-[color,box-shadow] focus-visible:outline-1 focus-visible:ring-[3px]"
      :as-child="delegatedProps.asChild"
    >
      <slot />
    </ScrollAreaViewport>
    <ScrollBar />
    <ScrollAreaCorner />
  </ScrollAreaRoot>
</template>
